import { WebSiteBrowser } from '../../components/WebSiteBrowser';
import React from 'react';
import { IWebProps } from './types';

export default class Web extends React.Component<IWebProps> {
  render() {
    return <WebSiteBrowser uri={this.props.route.params?.url} />;
  }
}
